<template>
    <div>
    <video :id="btn.code" :src="btn.mov"  controls="true" width="100%" height="100%"></video>
    <div v-if="!live" style="width:100%;height:100%;position: absolute;top:0px;left:0px"></div>
    </div>
</template>

<script>

export default {
    props: ['btn','live']
}    
</script>